import { createMutationHook, useApiQuery } from 'queries/common';

import firehydrantAPI from '../helpers/firehydrantAPI';

export const useIncidentRoles = (params = {}) => {
  const query = useApiQuery(
    [{ resource: 'incidentRoles' }, 'list', params],
    () => firehydrantAPI.get('incident_roles', { params }),
  );
  return {
    ...query,
    data: query.data?.data?.data ?? [],
  };
};

export const useIncidentRole = (id) => {
  const query = useApiQuery(
    [{ resource: 'incidentRoles' }, 'detail', id],
    () => firehydrantAPI.get(`/incident_roles/${id}`),
    { enabled: !!id },
  );
  return {
    ...query,
    data: query.data?.data ?? {},
  };
};

export const useCreateIncidentRoles = (options) =>
  createMutationHook((body) => firehydrantAPI.post('incident_roles', body))(
    options,
  );

export const useUpdateIncidentRoles = (options) =>
  createMutationHook((body) =>
    firehydrantAPI.patch(`/incident_roles/${body.id}`, body),
  )(options);

export const useDeleteIncidentRoles = (options) =>
  createMutationHook((id) => firehydrantAPI.delete(`/incident_roles/${id}`))(
    options,
  );
